import React, { forwardRef } from 'react'

import { ErrorIconSmall } from '@hm-group/fabric-icons/icons/ErrorIcon'
import { InputValidIconSmall } from '@hm-group/fabric-icons/icons/InputValidIcon'

import { NumberInputProps } from './types'
import BaseInput from '../BaseInput/BaseInput'

const NumberInput: React.FC<NumberInputProps> = forwardRef((props, ref) => {
  const { isSuccess, isInvalid, name } = props

  const afterContent = isSuccess ? (
    <InputValidIconSmall data-testid={`${name}-valid-after-content`} />
  ) : isInvalid ? (
    <ErrorIconSmall data-testid={`${name}-invalid-after-content`} />
  ) : null
  return <BaseInput {...props} type="number" ref={ref} afterContent={afterContent} />
})

export default NumberInput
